const countryTranslations = {
  ad: "Andorra",
  ae: "De forente arabiske emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østerrike",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnia-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgia",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibisk Nederland",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviterussland",
  bz: "Belize",
  ca: "Canada",
  cc: "Kokosøyene",
  cd: "Kongo-Kinshasa",
  cf: "Den sentralafrikanske republikk",
  cg: "Kongo-Brazzaville",
  ch: "Sveits",
  ci: "Elfenbenskysten",
  ck: "Cookøyene",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kapp Verde",
  cw: "Curaçao",
  cx: "Christmasøya",
  cy: "Kypros",
  cz: "Tsjekkia",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den dominikanske republikk",
  dz: "Algerie",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypt",
  eh: "Vest-Sahara",
  er: "Eritrea",
  es: "Spania",
  et: "Etiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøyene",
  fm: "Mikronesiaføderasjonen",
  fo: "Færøyene",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannia",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorial-Guinea",
  gr: "Hellas",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong S.A.R. Kina",
  hn: "Honduras",
  hr: "Kroatia",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesia",
  ie: "Irland",
  il: "Israel",
  im: "Man",
  in: "India",
  io: "Det britiske territoriet i Indiahavet",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Kambodsja",
  ki: "Kiribati",
  km: "Komorene",
  kn: "Saint Kitts og Nevis",
  kp: "Nord-Korea",
  kr: "Sør-Korea",
  kw: "Kuwait",
  ky: "Caymanøyene",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalløyene",
  mk: "Nord-Makedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao S.A.R. Kina",
  mp: "Nord-Marianene",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldivene",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Ny-Caledonia",
  ne: "Niger",
  nf: "Norfolkøya",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesia",
  pg: "Papua Ny-Guinea",
  ph: "Filippinene",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Puerto Rico",
  ps: "Det palestinske området",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russland",
  rw: "Rwanda",
  sa: "Saudi-Arabia",
  sb: "Salomonøyene",
  sc: "Seychellene",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sør-Sudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks- og Caicosøyene",
  td: "Tsjad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Øst-Timor",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Tyrkia",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "St. Vincent og Grenadinene",
  ve: "Venezuela",
  vg: "De britiske jomfruøyene",
  vi: "De amerikanske jomfruøyene",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sør-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
};
export default countryTranslations;